export var PrintRoleType;
(function (PrintRoleType) {
    PrintRoleType["receipt"] = "receipt";
    PrintRoleType["order"] = "order";
    PrintRoleType["bar"] = "bar";
    PrintRoleType["kitchen"] = "kitchen";
    PrintRoleType["sector_1"] = "sector_1";
    PrintRoleType["sector_2"] = "sector_2";
})(PrintRoleType || (PrintRoleType = {}));
//# sourceMappingURL=defPrint.js.map